import script from "./sw-item-parts-columns.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-columns.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-columns.vue?vue&type=style&index=0&id=1cf69544&lang=css"

const __exports__ = script;

export default __exports__